import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptReviewFailedAction = {
	type: 'TRANSCRIPT_REVIEW_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptReviewFailedAction => ({
	type: 'TRANSCRIPT_REVIEW_FAILED',
	payload,
});
